/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

import {
  getTheme,
  FontSizes,
  FontWeights,
  ICommandBarStyles,
  IStackItemStyles,
  IStackStyles,
  ITextStyles,
  IIconStyles,
} from "@fluentui/react";

const theme = getTheme();

export const wrapperStyles: IStackStyles = {
  root: {
    border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
    borderRadius: "0.5rem",
    padding: "2.25rem 1.5rem",
    boxShadow: "0px 1px 6px rgba(0, 0, 0, 0.2)",
    marginTop: "1.5rem",
  },
};

export const titleStyles: IStackItemStyles = {
  root: {
    padding: "1.5rem",
    background: theme.palette.neutralLight,
    borderRadius: "0.5rem",
  },
};

export const titleTextStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.size20,
    fontWeight: 600,
  },
};

export const commandBarStyles: ICommandBarStyles = {
  root: {
    marginTop: "0.5rem",
    selectors: {
      ["button"]: {
        padding: "0",
      },
    },
  },
};

export const copyIconStyles: IIconStyles = {
  root: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    color: theme.palette.blue,
  },
};
